export default "__VITE_ASSET__CI2ibD06__"